import { styled } from "../../../styled-components";

export const SimpleTableViewStyle = styled.div`
    position: relative;

    display: flex;

    flex-direction: column;
    ${p => p.theme.fontStyles.Body4};

    padding: ${p => p.theme.componentSmallInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;
    color: ${p => p.theme.fgColorDark};

    .sts-title {
        margin-bottom: 8px;

        ${p => p.theme.fontStyles.AccentHeader4};
    }

    .sts-row {
        min-height: 43px;
        border-bottom: 1px solid ${p => p.theme.separatorColor};

        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        :hover {
            color: ${p => p.theme.fgColorDark};
        }
    }

    .sts-row.click {
        cursor: pointer;
    }

    .sts-checkbox-wrap {
        pointer-events: none;
        margin: 12px 0;
    }

    .sts-row:last-child {
        min-height: 44px;
        border-bottom: unset;
    }

    .sts-label {
        padding: 12px 0;
        max-width: 65%;
        flex-shrink: 0;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .sts-value {
        padding: 12px 0;
        color: ${p => p.theme.fgColorMedium};
        flex-shrink: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        margin-left: 8px;

        display: flex;
        align-items: center;

        .chevron-hack {
            line-height: 0;
            margin: -5px -8px -5px 0px;
        }
    }

    .sts-value.text {
        display: block;
    }

    &.allowWrapping .sts-value {
        overflow: unset;
        white-space: pre-wrap;
        text-overflow: unset;
    }

    &.allowWrapping .sts-label {
        overflow: unset;
        white-space: pre-wrap;
        text-overflow: unset;
    }

    .sts-value.link {
        color: ${p => p.theme.primaryAccentColor};
    }

    .sts-value.image {
        height: 32px;
        padding: 0;
        margin: 12px 0;
        object-fit: contain;
        flex-shrink: 0;
    }

    .sts-footer {
        display: flex;
        align-items: center;

        margin-top: 8px;

        color: ${p => p.theme.fgColorMedium};
        ${p => p.theme.fontStyles.Body6};
    }
`;
